export const RECEIVE_WELCOME_MESSAGE = "RECEIVE_WELCOME_MESSAGE";



// WEBPACK FOOTER //
// ./template/state/modules/welcomeMessage/constants.js